import { read } from "Utils/Helpers/LocalStorage";
import instance from "http/Manager";

export const getTypes = () => {
  return instance.get(`/definitions/types/all/${read('main-local')}`);
};
export const createType = (name, color, doctors) => {
  const data = {
    clinic: read('main-local'),
    doctors: JSON.stringify(doctors),
    name,
    color
  }
  return instance.post(`/definitions/types`, data);
};

export const updateTypeNameColor = (id, name, color) => {
  return instance.put(`/definitions/types`, { clinic: read('main-local'), id, name, color });
};

export const changeStatusStatus = (id, status) => {
  return instance.put(`/definitions/status/one/status`, { id, status });
};

export const updateMessage = (message) => {
  return instance.put(`/settings/message`, { clinic: read('main-local'), message: JSON.stringify(message) });
};

export const createPosbank = (pos_name) => {
  return instance.post(`/settings/posbank`, { clinic: read('main-local'), pos_name });
};

export const updatePosbank = (pos_id, pos_name) => {
  return instance.put(`/settings/posbank`, { clinic: read('main-local'), pos_name, pos_id });
};

export const deletePosbank = (pos_id) => {
  return instance.post(`/settings/posbank-remove`, { clinic: read('main-local'), pos_id });
};

export const updateDaysLimits = (days, extra, times) => {
  const data = {
    clinic: read('main-local'),
    days: JSON.stringify(days),
    times: JSON.stringify(times),
    extra,
  }
  return instance.put(`/settings`, data);
};

export const deleteType = (id) => {
  return instance.delete(`/definitions/types/${id}`);
};